import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import Loader from '../../../../assets/images/spinner-DNA-2s-200px.svg';
var MESSAGES = ['Reading your job description…', 'Spotting key skills…', 'Matching to our picklist…'];
var SuggestingQualificationsLoader = /*#__PURE__*/function (_Component) {
  function SuggestingQualificationsLoader(props) {
    var _this;
    _classCallCheck(this, SuggestingQualificationsLoader);
    _this = _callSuper(this, SuggestingQualificationsLoader, [props]);
    _this.state = {
      messageIndex: 0
    };
    return _this;
  }
  _inherits(SuggestingQualificationsLoader, _Component);
  return _createClass(SuggestingQualificationsLoader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.interval = setInterval(function () {
        _this2.setState(function (_ref) {
          var messageIndex = _ref.messageIndex;
          return {
            messageIndex: (messageIndex + 1) % MESSAGES.length
          };
        });
      }, 1500);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: "render",
    value: function render() {
      var messageIndex = this.state.messageIndex;
      return /*#__PURE__*/React.createElement("div", {
        className: "project-loading-container suggesting-qualifications-loader vh-100"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-row--always g-row--centered h-100"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-center"
      }, /*#__PURE__*/React.createElement("img", {
        alt: "loader",
        src: Loader
      }), /*#__PURE__*/React.createElement("p", {
        className: "suggesting-qualifications-message"
      }, MESSAGES[messageIndex]))));
    }
  }]);
}(Component);
export default SuggestingQualificationsLoader;